var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"drawer-footer"},[_c('el-button',{attrs:{"size":"small","type":"default"},on:{"click":function($event){return _vm.$emit('close')}}},[_vm._v(" "+_vm._s(_vm.$t('generic.close'))+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }